<template>
    <div class="card">
        <div class="card-header">Personal Information</div>
        <div class="card-body">

            <b-row>
                <b-col cols="4">
                    <BaseTextInput v-model="application.profile.firstName"
                                   :v="$v.application.profile.firstName"
                                   slug="firstName"
                                   label="First Name"
                                   :plaintext="hasCertificate"
                    />
                </b-col>
                <b-col cols="4">
                    <BaseTextInput v-model="application.profile.middleName"
                                   :v="$v.application.profile.middleName"
                                   slug="middleName"
                                   label="Middle Name"
                                   :plaintext="hasCertificate"
                    />
                </b-col>
                <b-col cols="4">
                    <BaseTextInput v-model="application.profile.lastName"
                                   :v="$v.application.profile.lastName"
                                   slug="lastName"
                                   label="Last Name"
                                   :plaintext="hasCertificate"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="6">
                    <BaseDateOfBirthInput v-model="application.profile.dateOfBirth"
                                          :v="$v.application.profile.dateOfBirth"
                                          label="Date of Birth"
                                          :messages="dobMessages"
                                          slug="dob"
                                          setId="dob"
                                          tip="Format: MM/DD/YYYY"
                                          :plaintext="hasCertificate"
                    />
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseMaskedTextInput v-model="application.profile.ssn"
                                         :v="$v.application.profile.ssn"
                                         slug="ssn"
                                         label="Social Security Number"
                                         setId="ssn"
                                         mask="###-##-####"
                                         :plaintext="hasCertificate"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <BaseMaskedTextInput v-model="application.profile.contact.phone"
                                         :v="$v.application.profile.contact.phone"
                                         slug="phone"
                                         label="Cell Phone Number"
                                         setId="phone"
                                         mask="(###)###-####"
                    />
                </b-col>
                <b-col cols="6">
                    <BaseTextInput v-model="application.profile.contact.email"
                                   :v="$v.application.profile.contact.email"
                                   slug="email"
                                   label="Email"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <BaseSelector v-model="application.profile.textingPreferences"
                                  :v="$v.application.profile.textingPreferences"
                                  slug="textingPreference"
                                  label="Texting Preferences"
                                  :options="textingPreferenceOptions"/>
                </b-col>
            </b-row>
            <h2>
                Address:
            </h2>
            <b-row>
                <b-col cols="8">
                    <BaseTextInput v-model="application.profile.contact.address.streetAddress"
                                   :v="$v.application.profile.contact.address.streetAddress"
                                   slug="streetAddress"
                                   label="Street Address"
                                   tip="Please include apartment number or PO Box number if relevant."
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <BaseTextInput v-model="application.profile.contact.address.city"
                                   :v="$v.application.profile.contact.address.city"
                                   slug="city"
                                   label="City"
                    />
                </b-col>
                <b-col cols="4">
                    <BaseSelector v-model="application.profile.contact.address.state"
                                  :v="$v.application.profile.contact.address.state"
                                  label="State"
                                  slug="state"
                                  :options=opts.stateOptions
                    />
                </b-col>
                <b-col cols="4">
                    <BaseMaskedTextInput v-model="application.profile.contact.address.postalCode"
                                         :v="$v.application.profile.contact.address.postalCode"
                                         slug="postalCode"
                                         label="ZIP"
                                         mask="#####-####"
                    />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import BaseTextInput from "@/components/templates/input/BaseTextInput"
    import BaseSelector from "@/components/templates/input/BaseSelector"
    import { required, email, maxLength, minLength } from 'vuelidate/lib/validators'
    import minDate from '@/validators/minDate'
    import maxDate from '@/validators/maxDate'
    import {commonOptions} from "@/mixins/commonOptions"

    export default {

        components:{
            BaseTextInput,
            BaseSelector,
        },

        mixins: [
            commonOptions,
        ],

        props:{
            application: [Object],
            textingPreferenceOptions: [Array],
            hasCertificate: [Boolean]
        },

        data() {
            return {
                dobMessages: {
                    maxDate: 'Date of Birth cannot be in the future.',
                    minDate: 'Date of Birth must be after 01/01/1900.'
                },
            }
        },

        validations(){
            return{
                application: {
                    profile: {
                        firstName: {required},
                        lastName: {required},
                        middleName: {required:false},
                        ssn: {
                            required: required,
                            minLength: minLength(11),
                            maxLength: maxLength(11)
                        },
                        dateOfBirth: {
                            required,
                            maxDate: maxDate(new Date()),
                            minDate: minDate(new Date('1900-01-01'))
                        },
                        contact: {
                            required: true,
                            email: {required, email},
                            phone: {required},
                            address:{
                                required: true,
                                streetAddress: { required },
                                city: { required },
                                state: { required },
                                postalCode: {
                                    required,
                                    minLength: minLength(5),
                                    maxLength: maxLength(10)
                                },
                            }
                        },
                        textingPreferences: {required}
                    },
                },
                form: ["application"]
            }
        },
        methods:{
            validate(){
                this.$v.form.$touch();
                let isValid = !this.$v.form.$invalid;
                this.$emit('on-validate', this.$data.application, isValid);
                return isValid;
            },
        },

    }
</script>